/**
 * Common utilities for WPS Transaction components
 */

import { showSuccess, showError, showWarning, showInfo } from "../../notifications/Toaster";
import { MessageTypes } from "../../../common/constants/CommonConstants";

// Common toast message configurations
export const TOAST_MESSAGES = {
  [MessageTypes.Success]: { type: 'success', message: 'Data Added Successfully', navigate: true },
  [MessageTypes.Fail]: { type: 'warning', message: 'Failed, Data could not be saved' },
  [MessageTypes.Required]: { type: 'warning', message: 'Required Fields not filled' },
  [MessageTypes.SpecialCharacters]: { type: 'warning', message: process.env.REACT_APP_SPECIAL_CHARACTER_MSG },
  [MessageTypes.RequiredAll]: { type: 'warning', message: 'Required Fields not filled.Please check and Fill Required Fields for all 3 Pages.' },
  [MessageTypes.Band]: { type: 'warning', message: 'Data Temporary Saved but P and T band welding engineers not present in User Master. Cannot sent for approval' },
  [MessageTypes.Temp]: { type: 'success', message: 'Temporary Saved Data Successfully' },
  [MessageTypes.ProcessDeleted]: { type: 'success', message: 'Process Deleted Successfully' },
  [MessageTypes.ProcessDeleteFailed]: { type: 'warning', message: 'Process could not be deleted' }
};

/**
 * Show toast message based on message type
 */
export const showToast = (messageType, key = null, setKey = null, maxTabs = null, navigate = false) => {
  const config = TOAST_MESSAGES[messageType];
  if (config) {
    const toastFunctions = {
      success: showSuccess,
      warning: showWarning,
      error: showError,
      info: showInfo
    };
    let message = config.message;
    if (messageType === MessageTypes.RequiredAll && maxTabs) {
      message = `Required Fields not filled.Please check and Fill Required Fields for all ${maxTabs} Pages.`;
    }
    toastFunctions[config.type]?.(message);
    if (navigate && config.navigate && key !== null && setKey !== null && key !== maxTabs) {
      setKey(+key + 1);
    }
  }
};

/**
 * Execute child component function
 */
export const executeChildFunction = async (refs, key, funcName) => {
  const currentRef = refs[key - 1];
  return currentRef?.current?.[funcName]?.() || false;
};

/**
 * Handle navigation between tabs
 */
export const handleNavigation = (tabaction, e, key, setKey, maxTabs) => {
  const actions = {
    prev: () => key !== 1 && setKey(+key - 1),
    next: () => key !== maxTabs && setKey(+key + 1),
    tab: () => setKey(+e)
  };
  actions[tabaction]?.();
};

/**
 * Get session storage data
 */
export const getSessionData = () => ({
  UserName: sessionStorage.getItem("UserName"),
  UserId: sessionStorage.getItem("UserId"),
  Band: sessionStorage.getItem("Band"),
  User: sessionStorage.getItem("User")
});

/**
 * Create log object
 */
export const createLogObject = (headerObj, sessionData) => ({
  WPSH_Project_No_log: headerObj?.WPSH_Project_No || "",
  WPSH_WPS_No_log: headerObj?.WPSH_WPS_No || "",
  WPSH_User_Name_log: sessionData.UserName,
  WPSH_User_Id_log: sessionData.UserId,
  WPSH_Status_log: "",
});

/**
 * Setup beforeunload event listeners
 */
export const setupBeforeUnloadListeners = (editedPages) => {
  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
  };
  
  const events = ["beforeunload", "unload"];
  events.forEach(event => window.addEventListener(event, alertUser));
  
  return () => {
    events.forEach(event => window.removeEventListener(event, alertUser));
  };
};

/**
 * Common ToastContainer props
 */
export const TOAST_CONTAINER_PROPS = {
  autoClose: 3000,
  hideProgressBar: true,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true,
  theme: "colored"
};

/**
 * Common tab style
 */
export const getTabStyle = () => ({
  height: window.innerHeight - 180,
  overflowY: "auto",
  overflowX: "hidden",
});

/**
 * Common button styles
 */
export const BUTTON_STYLES = {
  width: "100px",
  height: "38px"
};